export default {
  createDocument(documentTypeId, rules) {
    return {
      file: null,
      documentTypeName:
        this.getDocumentType && this.getDocumentType(documentTypeId).name,
      documentTypeId,
      rules,
    };
  },
};
